export enum HallPassStatuses {
    Active = 1,
    ExpiredRequest = 2,
    Denied = 3,
    Pending = 4,
    Cancelled = 5,
    ExpiredReturn = 6,
    Returned = 7
}

export enum AcornOrderStatuses {
    Processing = 1, //New Order
    Pending = 2, //Ready for Pickup
    Fulfilled = 3, //Completed
    PartiallyFulfilled = 4,
    Cancelled = 5
}